import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { formatDate, onlyNumeric } from '../../../commonClass/CommonValidation';
import CustomTable from '../../../../customControl/CustomTable';
import { useLocation } from 'react-router-dom';
import { getTitleName } from './HomePageSection';
import CustomColumn from '../../../../customControl/CustomColumn';
import Switch from 'react-switch';
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import { areArraysEqualIgnoreOrder } from '../../../commonClass/CommonFunctions';
import CommonFilter from '../../../../customControl/CommonFilter';

const Collection = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { useredit, useradd, name, travelCategoryId } = location.state || {};
    const [dataList, setDataList] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [options, setOptions] = useState([])
    const [formError, setFormError] = useState({});
    const [editDisable, setEditDisable] = useState(true)

    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);

    const [formValue, setFormValue] = useState(
        {
            UserId: 0,
            collectionMerchandisingId: 0,
            collectionId: 0,
            categoryIds: [],
            activityIds: [],
            isActive: false,
            seqNo: null,
        }
    )

    const [modalShow, setModalShow] = useState(false);
    const handleisActive = (e) => {
        if (formValue?.type === 'edit') {
            setModalShow(true);
        }
        else {
            formValue.isActive = e
            setFormError({});
        }
    }

    const handleConfirmation = (e, val) => {
        if (val === true) {
            formValue.isActive = !formValue.isActive
            setEditDisable(false);
            setFormError({});
        }
        setModalShow(false);
    }

    const getdatalist = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            dispatch(loaderActions.start());
            const data = await getAllData(`/master/v1/getcollectionmerchandisinglist`);
            if (data?.status) {
                data?.data?.map((obj) => {
                    obj.Active = obj.IsActive ? 'Active' : 'InActive'
                    obj.ActivityIds = JSON?.parse(obj?.ActivityIds)
                    obj.CategoryIds = JSON?.parse(obj?.CategoryIds)
                    return obj;
                })
                setDataList(data?.data)
                setFilterData(data?.data)
            }
            else {
                setDataList([])
                setFilterData([])
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const getcollectionmerchandisingoption = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const data = await getAllData(`/master/v1/getcollectionmerchandisingoption`);
            if (data?.status) {
                setOptions(data?.data)
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    //#region List data
    useEffect(() => {
        getdatalist();
        getcollectionmerchandisingoption()
    }, []);

    const handleChange = (name, val) => {
        setEditDisable(false)
        setFormError({});
        if (name === 'collectionId') {
            setFormValue((pre) => ({ ...pre, [name]: val, categoryIds: [], activityIds: [] }));
        }
        else if (name === 'categoryIds') {
            setFormValue((pre) => ({ ...pre, [name]: val?.map((el) => el?.value), activityIds: [] }));
        }
        else if (name === 'activityIds') {
            setFormValue((pre) => ({ ...pre, [name]: val?.map((el) => el?.value) }));
        }
        else {
            setFormValue((pre) => ({ ...pre, [name]: val }));
        }
    }

    const checkValidation = () => {
        let errorMessages = {};
        let isError = true;

        if (formValue?.collectionId === 0 || formValue?.collectionId === null) {
            errorMessages['collectionId'] = 'Input is mandatory, cannot leave blank.'
            isError = false;
        }
        if (formValue?.collectionId !== 0 && formValue?.categoryIds?.length <= 0) {
            errorMessages['categoryIds'] = 'Input is mandatory, cannot leave blank.'
            isError = false;
        }
        if (formValue?.collectionId !== 0 && formValue?.categoryIds?.length > 0 && formValue?.activityIds?.length <= 0) {
            errorMessages['activityIds'] = 'Input is mandatory, cannot leave blank.'
            isError = false;
        }
        if (dataList?.some((el) => el.CollectionMerchandisingId !== formValue?.collectionMerchandisingId && el.SequenceNo === (formValue?.seqNo ? formValue?.seqNo : ''))) {
            errorMessages['seqNo'] = 'This number already exists.'
            isError = false;
        }
        setFormError(errorMessages);
        return isError;
    }

    const onSubmitData = async () => {
        const isValid = checkValidation();
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (isValid) {
                let user = GetLocalStorage();
                formValue.UserId = user?.userMasterID
                const res = await postUsersData('/master/v1/usertcollectionselection', formValue);
                if (res?.status) {
                    dispatch(loaderActions.end());
                    getdatalist();
                    onClearButton();
                    dispatch({ type: 'ALERTING', message: res.message })
                }
                else {
                    dispatch(loaderActions.end());
                    dispatch({ type: 'ALERTING', message: res.message })
                    return;
                }
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const columns = [
        {
            name: 'Collection Name',
            key: 'CollectionName',
            sortable: true,
            float: "left",
            selector: (data) => data?.CollectionName,
        },
        {
            name: 'Category Name',
            key: 'CategoryName',
            sortable: true,
            float: "left",
            selector: (data) => data?.CategoryName,
        },
        {
            name: 'Activity Name',
            key: 'ActivityName',
            sortable: true,
            float: "left",
            selector: (data) => data?.ActivityName,
        },
        {
            name: 'Created Date',
            sortable: true,
            float: "left",
            selector: (data) => new Date(data?.CreatedDate),
            format: (data) => formatDate(data?.CreatedDate)
        },
        {
            name: 'Active',
            key: 'Active',
            sortable: true,
            float: "left",
            selector: (data) => data?.Active,
        },
        {
            name: 'Image Name',
            sortable: true,
            float: "left",
            selector: (data) => data?.ImageName,
        },
        {
            name: 'Edit',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'edit')} disabled={!useredit}
            ><i className="fa fa-edit eye-icon"></i></button>
        },
        {
            name: 'View',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'view')} ><i className="fa fa-eye" ></i></button>
        }
    ]

    const onEditorView = async (data, type) => {
        setFormError({});
        if (type === 'view') {
            setSerachDisable(true)
        }
        setEditDisable(true)
        setFormValue((pre) => ({
            ...pre,
            activityIds: data?.ActivityIds ? data?.ActivityIds : [],
            categoryIds: data?.CategoryIds ? data?.CategoryIds : [],
            collectionId: data?.CollectionId ? data?.CollectionId : 0,
            collectionMerchandisingId: data?.CollectionMerchandisingId ? data?.CollectionMerchandisingId : 0,
            isActive: data?.IsActive ? data?.IsActive : false,
            seqNo: data?.SequenceNo ? data?.SequenceNo : null,
            type: type
        }));

    }

    const onClearButton = () => {
        setFormError({});
        setEditDisable(false);
        setSerachDisable(false)
        setFormValue((pre) => ({
            ...pre,
            collectionMerchandisingId: 0,
            collectionId: 0,
            categoryIds: [],
            activityIds: [],
            isActive: false,
            seqNo: null,
            UserId: 0,
            type :'Add'
        }));
    }

    return (
        <>
            <div class="container-fluid mt-4 heading_color">
                <h3>{getTitleName(travelCategoryId)}</h3>
            </div>
            <div class="container-fluid form_border pb-5 pt-4 my-3">
                <div className='px-xl-5'>
                    <div className=" heading_color mb-3">
                        <h4>{name}</h4>
                    </div>

                    <form action=" " className=' mb-5' >
                        <div className='row'>

                            <CustomColumn labelText='Select Collection' labelId='collectionId' isRequired >
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='collectionId'
                                    options={options?.collectionWiseCategory}
                                    onChange={(el) => handleChange('collectionId', el.value ? el.value : 0)}
                                    isSearchable
                                    value={options?.collectionWiseCategory?.filter((val) => (val.value === formValue?.collectionId)) || 0}
                                    isDisabled={formValue?.type === 'view' ? true : false}
                                    placeholder='Select Collection'
                                />
                                {formError?.collectionId && <p className="text-start text-danger mb-0"> {formError?.collectionId} </p>}
                            </CustomColumn>
                            <CustomColumn labelText='Select Category' labelId='categoryIds' isRequired >
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='categoryIds'
                                    options={options?.collectionWiseCategory?.find((el) => el.value === formValue?.collectionId)?.categories}
                                    value={(options?.collectionWiseCategory?.find((el) => el.value === formValue?.collectionId)?.categories)?.filter((prev) => formValue?.categoryIds?.includes(prev.value)) || []}
                                    onChange={(e) => handleChange('categoryIds', e ? e : [])}
                                    isMulti
                                    isSearchable
                                    isDisabled={formValue?.type === 'view' ? true : false || !formValue?.collectionId}
                                    placeholder='Select Category'
                                />
                                {formError?.categoryIds && <p className="text-start text-danger mb-0"> {formError?.categoryIds} </p>}
                            </CustomColumn>
                            <CustomColumn labelText='Select Activity' labelId='activityIds' isRequired >
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='activityIds'
                                    options={options?.activityList?.filter((el) => areArraysEqualIgnoreOrder(el.categoryIds, formValue?.categoryIds))}
                                    value={options?.activityList?.filter((el) => areArraysEqualIgnoreOrder(el.categoryIds, formValue?.categoryIds))?.filter((prev) => formValue?.activityIds?.includes(prev.value)) || []}
                                    onChange={(e) => handleChange('activityIds', e ? e : [])}
                                    isMulti
                                    isSearchable
                                    isDisabled={formValue?.type === 'view' ? true : false || !formValue?.collectionId || formValue?.categoryIds?.length <= 0}
                                    placeholder='Select Activity'
                                />
                                {formError?.activityIds && <p className="text-start text-danger mb-0"> {formError?.activityIds} </p>}
                            </CustomColumn>

                            <CustomColumn labelText='Sequence Number' labelId='seqNo' >
                                <input
                                    type="text"
                                    className='form-control'
                                    name="seqNo"
                                    id="seqNo"
                                    value={formValue?.seqNo || ''}
                                    onChange={(val) => handleChange('seqNo', Number(onlyNumeric(val?.target?.value)) > 0 ? Number(onlyNumeric(val?.target?.value)) : null)}
                                    disabled={formValue?.type === 'view' ? true : false}
                                    placeholder='Sequence Number'
                                />
                                {formError?.seqNo && <p className="text-start text-danger mb-0"> {formError?.seqNo} </p>}
                            </CustomColumn>

                            <CustomColumn colNum={6} labelText='Active' labelId='Active'>
                                <Switch
                                    onChange={handleisActive}
                                    checked={formValue?.isActive}
                                    className="react-switch"
                                    disabled={formValue?.type === 'view' ? true : false}
                                />
                                <ConfirmationModal
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                    noconfirm={() => handleConfirmation("Active", false)}
                                    yesconfirm={() => handleConfirmation("Active", true)}
                                />
                            </CustomColumn>


                        </div>
                    </form>
                    <CommonFilter
                        columns={columns}
                        filterList={filterData}
                        searchDisabled={serchdisable}
                        getdata={getdatalist}
                        setlistdata={setDataList}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={dataList}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={false}
                    />

                    <div class="d-flex justify-content-center">
                        {
                            formValue?.type === 'edit'
                                ? (<button class="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={editDisable || !useredit}
                                >Update</button>
                                )
                                : (<button class="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={(formValue?.type === 'view' ? editDisable : false) || !useradd}
                                >Add</button>)
                        }

                        <button type="button" class="btn btn-primary mx-1" id="btnClear"
                            onClick={() => onClearButton({})}
                        >Clear</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Collection